/**
 * Shared MUI Dialog chrome for coach-directory explainer modals and
 * other coach-profile surfaces that match the Career Services modal
 * treatment (centered navy Source Serif title, floating close, pill CTA).
 */
export function coachProfileModalStyleRules(theme) {
  return {
    paper: {
      position: 'relative',
      borderRadius: 12,
      '&.MuiDialog-paperFullScreen': {
        borderRadius: 0,
      },
    },
    paperScrollPaper: {
      overflow: 'visible',
      maxHeight: 'none',
    },
    titleText: {
      margin: 0,
      textAlign: 'center',
      color: theme.palette.secondary.light,
      padding: theme.spacing(0, 4),
    },
    closeButton: {
      position: 'absolute',
      top: theme.spacing(1.5),
      right: theme.spacing(1.5),
      zIndex: 1,
      flexShrink: 0,
      cursor: 'pointer',
      color: theme.palette.grey[500],
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: '0 0 auto',
      overflow: 'visible',
      gap: theme.spacing(2),
      padding: theme.spacing(4, 3, 2.5),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4.5, 4, 3),
        gap: theme.spacing(2.5),
      },
    },
    bodyStack: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      padding: theme.spacing(0, 2),
    },
    bodyParagraph: {
      margin: 0,
      color: theme.palette.text.primary,
    },
    bodyParagraphLead: {
      fontWeight: 700,
      '&.MuiTypography-root': {
        fontWeight: 700,
      },
    },
    leadText: {
      margin: 0,
      color: theme.palette.text.primary,
      fontWeight: 700,
      '&.MuiTypography-root': {
        fontWeight: 700,
      },
    },
    bodyText: {
      margin: 0,
      color: theme.palette.text.primary,
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1.5),
      padding: theme.spacing(0, 5, 5),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 6, 6),
      },
    },
    cta: {
      cursor: 'pointer',
      borderRadius: 999,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
      fontWeight: 700,
      textTransform: 'none',
      boxShadow: 'none',
    },
    ctaDismiss: {
      '&&': {
        backgroundColor: theme.palette.grey.dark,
        color: theme.palette.common.white,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: theme.palette.grey.darker,
          boxShadow: 'none',
          color: theme.palette.common.white,
        },
      },
    },
  }
}
